/* SWIFF storefront behaviour — no dependencies. */
(function () {
  'use strict';

  var money = window.SWIFF_MONEY_FORMAT || '₹{{amount}}';
  var routes = window.SWIFF_ROUTES || {};

  function fmt(cents) {
    var v = (cents / 100).toFixed(2).replace(/\.00$/, '');
    v = v.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return money.replace(/\{\{\s*amount[^}]*\}\}/, v);
  }

  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  /* ---------- Toast ---------- */
  var toastEl;
  function toast(msg, isError) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.className = 'toast is-on' + (isError ? ' toast--error' : '');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.className = 'toast'; }, 3600);
  }
  window.swiffToast = toast;

  /* ---------- Header state ---------- */
  var header = $('.header');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-stuck', window.scrollY > 24);
      var atc = $('.sticky-atc');
      if (atc) atc.classList.toggle('is-on', window.scrollY > 520);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Mobile nav ---------- */
  var burger = $('[data-burger]');
  var mnav = $('.mnav');
  if (burger && mnav) {
    burger.addEventListener('click', function () {
      var open = mnav.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      header.classList.toggle('is-open', open);
      document.body.style.overflow = open ? 'hidden' : '';
    });
  }

  /* ---------- Search ---------- */
  var searchToggle = $('[data-search-toggle]');
  var searchbar = $('.searchbar');
  if (searchToggle && searchbar) {
    var input = $('input[name="q"]', searchbar);
    var out = $('.suggest', searchbar);
    searchToggle.addEventListener('click', function () {
      var open = searchbar.classList.toggle('is-open');
      searchToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) input.focus();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        searchbar.classList.remove('is-open');
        $('.drawer') && $('.drawer').classList.remove('is-open');
      }
    });

    var timer, lastQ = '';
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { out.innerHTML = ''; return; }
      timer = setTimeout(function () {
        if (q === lastQ) return;
        lastQ = q;
        var url = (routes.predictive || '/search/suggest.json') +
          '?q=' + encodeURIComponent(q) +
          '&resources[type]=product,collection&resources[limit]=6';
        fetch(url)
          .then(function (r) { return r.json(); })
          .then(function (d) {
            var res = (d.resources && d.resources.results) || {};
            var products = res.products || [];
            var collections = res.collections || [];
            if (!products.length && !collections.length) {
              out.innerHTML = '<p class="suggest__empty">Nothing matched &ldquo;' +
                q.replace(/[<>&]/g, '') + '&rdquo;. Try a broader term, or browse the full collection.</p>';
              return;
            }
            var html = '';
            collections.forEach(function (c) {
              html += '<a href="' + c.url + '"><span class="suggest__meta">Collection</span>' +
                '<span class="suggest__name">' + c.title + '</span></a>';
            });
            products.forEach(function (p) {
              var img = p.featured_image && p.featured_image.url
                ? '<img src="' + p.featured_image.url + '" alt="" loading="lazy">'
                : '<span class="suggest__img"></span>';
              html += '<a href="' + p.url + '">' + img +
                '<span><span class="suggest__name">' + p.title + '</span><br>' +
                '<span class="suggest__meta">' + (p.price ? fmt(p.price) : '') + '</span></span></a>';
            });
            out.innerHTML = html;
          })
          .catch(function () {
            out.innerHTML = '<p class="suggest__empty">Search is unavailable right now. Press Enter to run a full search.</p>';
          });
      }, 220);
    });
  }

  /* ---------- Cart drawer ---------- */
  var drawer = $('.drawer');
  function openDrawer() { if (drawer) { drawer.classList.add('is-open'); document.body.style.overflow = 'hidden'; } }
  function closeDrawer() { if (drawer) { drawer.classList.remove('is-open'); document.body.style.overflow = ''; } }
  $$('[data-cart-open]').forEach(function (b) {
    b.addEventListener('click', function (e) { e.preventDefault(); refreshCart(); openDrawer(); });
  });
  $$('[data-cart-close]').forEach(function (b) { b.addEventListener('click', closeDrawer); });

  function renderDrawer(cart) {
    var body = $('[data-drawer-body]');
    var foot = $('[data-drawer-foot]');
    if (!body) return;
    if (!cart.item_count) {
      body.innerHTML = '<div class="empty"><h2 class="h3">Your cart is waiting.</h2>' +
        '<p>Nothing here yet.</p><a class="btn btn--sm" href="' + (routes.all || '/collections/all') +
        '"><span>Explore products</span></a></div>';
      if (foot) foot.innerHTML = '';
      return;
    }
    var html = '';
    cart.items.forEach(function (i, idx) {
      html += '<div class="line">' +
        '<div class="line__media">' + (i.image ? '<img src="' + i.image + '" alt="">' : '') + '</div>' +
        '<div><a class="line__name" href="' + i.url + '">' + i.product_title + '</a>' +
        (i.variant_title && i.variant_title !== 'Default Title'
          ? '<div class="line__variant">' + i.variant_title + '</div>' : '') +
        '<div class="qty"><button type="button" data-qty="' + (idx + 1) + '" data-delta="-1" aria-label="Reduce quantity">&minus;</button>' +
        '<input type="number" value="' + i.quantity + '" min="0" data-qty-input="' + (idx + 1) + '" aria-label="Quantity">' +
        '<button type="button" data-qty="' + (idx + 1) + '" data-delta="1" aria-label="Increase quantity">+</button></div>' +
        '<a class="line__remove" href="#" data-remove="' + (idx + 1) + '">Remove</a></div>' +
        '<div class="line__total">' + fmt(i.final_line_price) + '</div></div>';
    });
    body.innerHTML = html;
    if (foot) {
      foot.innerHTML = '<div class="summary__row"><span>Subtotal</span><span>' + fmt(cart.total_price) + '</span></div>' +
        '<p class="summary__note">Shipping and taxes are calculated at checkout.</p>' +
        '<a class="btn btn--solid btn--full" href="' + (routes.checkout || '/checkout') + '"><span>Proceed to checkout</span></a>' +
        '<a class="btn btn--ghost btn--full" style="margin-top:10px" href="' + (routes.cart || '/cart') + '"><span>View cart</span></a>';
    }
  }

  function setCount(n) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      if (n > 0) { el.removeAttribute('hidden'); } else { el.setAttribute('hidden', ''); }
    });
  }

  function refreshCart() {
    return fetch((routes.cart || '/cart') + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { setCount(cart.item_count); renderDrawer(cart); return cart; })
      .catch(function () { });
  }

  function changeLine(line, qty) {
    return fetch((routes.change || '/cart/change.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { setCount(cart.item_count); renderDrawer(cart); return cart; })
      .catch(function () { toast('We could not update your cart. Please try again.', true); });
  }

  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-qty]');
    if (q) {
      var input = $('[data-qty-input="' + q.dataset.qty + '"]');
      var next = Math.max(0, parseInt(input.value, 10) + parseInt(q.dataset.delta, 10));
      changeLine(parseInt(q.dataset.qty, 10), next);
      return;
    }
    var rm = e.target.closest('[data-remove]');
    if (rm) { e.preventDefault(); changeLine(parseInt(rm.dataset.remove, 10), 0); }
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-qty-input]');
    if (input) changeLine(parseInt(input.dataset.qtyInput, 10), Math.max(0, parseInt(input.value, 10) || 0));
  });

  /* ---------- Add to cart ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-atc-form]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.innerHTML = '<span>Adding…</span>'; }

    fetch(routes.add || '/cart/add.js', { method: 'POST', body: new FormData(form) })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.d.description || res.d.message || 'Could not add to cart');
        return refreshCart().then(function () {
          if (form.dataset.buyNow === 'true') { window.location.href = routes.checkout || '/checkout'; return; }
          openDrawer();
        });
      })
      .catch(function (err) { toast(err.message, true); })
      .finally(function () { if (btn) { btn.removeAttribute('aria-disabled'); btn.innerHTML = label; } });
  });

  /* ---------- Quantity steppers outside the drawer ---------- */
  $$('[data-qty-step]').forEach(function (b) {
    b.addEventListener('click', function () {
      var input = $('#' + b.dataset.qtyStep);
      if (!input) return;
      var next = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.dataset.delta, 10));
      input.value = next;
    });
  });

  /* ---------- Wishlist (local, syncs to account on request) ---------- */
  var KEY = 'swiff_wishlist';
  function readWish() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function writeWish(v) { try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) { } }

  function paintWish() {
    var list = readWish();
    $$('[data-wish]').forEach(function (b) {
      b.classList.toggle('is-saved', list.indexOf(b.dataset.wish) > -1);
      b.setAttribute('aria-pressed', list.indexOf(b.dataset.wish) > -1 ? 'true' : 'false');
    });
    $$('[data-wish-count]').forEach(function (el) { el.textContent = list.length; });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-wish]');
    if (!b) return;
    e.preventDefault();
    var list = readWish();
    var handle = b.dataset.wish;
    var i = list.indexOf(handle);
    if (i > -1) { list.splice(i, 1); toast('Removed from your wishlist.'); }
    else { list.push(handle); toast('Saved to your wishlist.'); }
    writeWish(list);
    paintWish();
    if (window.SWIFF_WISHLIST_PAGE) renderWishlistPage();
  });
  paintWish();

  /* ---------- Wishlist page ---------- */
  function renderWishlistPage() {
    var host = $('[data-wishlist-grid]');
    if (!host) return;
    var list = readWish();
    if (!list.length) {
      host.innerHTML = '<div class="empty"><h2 class="h2">Save something you love.</h2>' +
        '<p>Tap the heart on any product and it will be waiting here.</p>' +
        '<a class="btn" href="' + (routes.all || '/collections/all') + '"><span>Explore products</span></a></div>';
      return;
    }
    host.innerHTML = '<p class="toolbar__count">Loading your saved items…</p>';
    Promise.all(list.map(function (h) {
      return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (items) {
      var html = '<div class="grid grid--4">';
      var live = 0;
      items.forEach(function (p, idx) {
        if (!p) return;
        live++;
        var img = p.featured_image ? '<img src="' + p.featured_image + '&width=700" alt="' + p.title + '" loading="lazy">' :
          '<span class="card__placeholder">Swiff</span>';
        html += '<article class="card"><a class="card__media" href="' + p.url + '">' + img + '</a>' +
          '<button class="wish is-saved" data-wish="' + list[idx] + '" aria-pressed="true" aria-label="Remove from wishlist">' +
          '<svg viewBox="0 0 24 24"><path d="M12 20.5 3.8 12.3a5 5 0 1 1 7.1-7.1l1.1 1.1 1.1-1.1a5 5 0 1 1 7.1 7.1Z"/></svg></button>' +
          '<div class="card__body"><a class="card__name" href="' + p.url + '">' + p.title + '</a>' +
          '<div class="card__price">' + fmt(p.price) + '</div>' +
          (p.available
            ? '<form data-atc-form method="post" action="' + (routes.add || '/cart/add') + '">' +
            '<input type="hidden" name="id" value="' + p.variants[0].id + '">' +
            '<button class="btn btn--sm btn--full" type="submit" style="margin-top:10px"><span>Add to cart</span></button></form>'
            : '<span class="card__sold">Sold out</span>') +
          '</div></article>';
      });
      html += '</div>';
      host.innerHTML = live ? html :
        '<div class="empty"><h2 class="h2">Save something you love.</h2><p>Your saved items are no longer available.</p>' +
        '<a class="btn" href="' + (routes.all || '/collections/all') + '"><span>Explore products</span></a></div>';
      paintWish();
    });
  }
  if ($('[data-wishlist-grid]')) { window.SWIFF_WISHLIST_PAGE = true; renderWishlistPage(); }

  /* ---------- Product gallery ---------- */
  var main = $('[data-gallery-main]');
  if (main) {
    $$('[data-gallery-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        var img = $('img', main);
        img.src = t.dataset.full;
        img.alt = t.dataset.alt || '';
        $$('[data-gallery-thumb]').forEach(function (x) { x.setAttribute('aria-current', 'false'); });
        t.setAttribute('aria-current', 'true');
        main.classList.remove('is-zoomed');
      });
    });
    main.addEventListener('click', function () { main.classList.toggle('is-zoomed'); });
    main.addEventListener('mousemove', function (e) {
      if (!main.classList.contains('is-zoomed')) return;
      var r = main.getBoundingClientRect();
      var img = $('img', main);
      img.style.transformOrigin =
        ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
    });
  }

  /* ---------- Variant selection ---------- */
  var variantForm = $('[data-variant-form]');
  if (variantForm && window.SWIFF_VARIANTS) {
    var selects = $$('[data-option]', variantForm);
    var idField = $('[name="id"]', variantForm);
    var priceEl = $('[data-variant-price]');
    var stockEl = $('[data-variant-stock]');
    var submitEl = $('[data-variant-submit]');

    var sync = function () {
      var chosen = selects.map(function (s) { return s.value; });
      var match = window.SWIFF_VARIANTS.filter(function (v) {
        return chosen.every(function (val, i) { return v.options[i] === val; });
      })[0];
      if (!match) {
        if (stockEl) { stockEl.textContent = 'This combination is unavailable'; stockEl.classList.add('pdp__stock--out'); }
        if (submitEl) submitEl.setAttribute('aria-disabled', 'true');
        return;
      }
      idField.value = match.id;
      if (priceEl) {
        priceEl.innerHTML = fmt(match.price) +
          (match.compare_at_price > match.price ? ' <s class="price--was">' + fmt(match.compare_at_price) + '</s>' : '');
      }
      if (stockEl) {
        stockEl.textContent = match.available ? 'In stock — ready to ship' : 'Sold out';
        stockEl.classList.toggle('pdp__stock--out', !match.available);
      }
      if (submitEl) {
        if (match.available) { submitEl.removeAttribute('aria-disabled'); submitEl.innerHTML = '<span>Add to cart</span>'; }
        else { submitEl.setAttribute('aria-disabled', 'true'); submitEl.innerHTML = '<span>Sold out</span>'; }
      }
      var url = new URL(window.location);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url);
    };
    selects.forEach(function (s) { s.addEventListener('change', sync); });
  }

  /* ---------- Password reveal ---------- */
  $$('[data-pw-toggle]').forEach(function (b) {
    b.addEventListener('click', function () {
      var input = $('#' + b.dataset.pwToggle);
      var show = input.type === 'password';
      input.type = show ? 'text' : 'password';
      b.textContent = show ? 'Hide' : 'Show';
      b.setAttribute('aria-label', show ? 'Hide password' : 'Show password');
    });
  });

  /* ---------- Sort & filter submit ---------- */
  $$('[data-auto-submit]').forEach(function (s) {
    s.addEventListener('change', function () { s.form.submit(); });
  });

  /* ---------- Scroll reveal ---------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: .08 });
    $$('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    $$('.reveal').forEach(function (el) { el.classList.add('is-in'); });
  }

  refreshCart();
})();
